import { Permissions } from '@cccom/auth/permissions-type';

const APP_FAMILY_NAMES = {
  VIEW: 'VIEW',
  QI: 'QI',
  SOLUTIONS: 'SOLUTIONS',
};

export const APP_IDS = {
  HOME: 'HOME',
  QI: 'QI',
  ATREVIEW: 'ATREVIEW',
  SYSTEM_INVENTORY: 'SYSTEM_INVENTORY',
  ELOGBOOK: 'ELOGBOOK',
  ALARM_REVIEW: 'ALARM_REVIEW',
  UNAUTHORIZED: 'UNAUTHORIZED',
} as const;

export const APP_TIERS = {
  NONE: 'NONE',
  REGISTRY_TIER: 'REGISTRY_TIER',
} as const;

type ObjectValues<T> = T[keyof T];

export type AppStatus = 'ACTIVE' | 'FUTURE';
export type AppFamilyNames = ObjectValues<typeof APP_FAMILY_NAMES>;
export type AppIds = ObjectValues<typeof APP_IDS>;
export type AppTiers = ObjectValues<typeof APP_TIERS>;

export type AppMenu = {
  [APP_IDS.HOME]: 'apps';
  [APP_IDS.QI]: 'environments' | 'groups' | 'activity-log';
  [APP_IDS.ATREVIEW]:
    | 'dashboard'
    | 'parameter-changes'
    | 'exempted-events'
    | 'systems'
    | 'inclusions'
    | 'non-attributable-users'
    | 'activity-log'
    | 'settings';
  [APP_IDS.SYSTEM_INVENTORY]: 'systems' | 'activity-log';
  [APP_IDS.ELOGBOOK]: 'builder' | 'logbooks' | 'all-entries' | 'activity-log';
  [APP_IDS.ALARM_REVIEW]: 'alarms' | 'activity-log';
  [APP_IDS.UNAUTHORIZED]: undefined;
};

export type App = {
  id: AppIds;
  name: string;
  status: AppStatus;
  logo: string;
  path: string; // for serving on docker or prod
  port: string; // for serving locally
  theme: Record<string, any>;
  errorLogo: string;
  homePage: string;
  appFamily: AppFamilyNames;
  scopes: Permissions[];
  description?: string;
  lastAccessed?: boolean;
  helpCenter?: string;
  tier?: AppTiers;
};
